// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"e2837025","977":"848a8d21"}[chunkId] + ".chunk.js");